import {Box, Center, Spinner, Text, VStack} from '@chakra-ui/react';
import {Navigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useHalCollection, useHalState} from '@synako/haligator';
import {useClient} from '@/haligator-factory';
import {usePeutVoirUBEssentielles} from '@/hooks/auth/usePermissionsCommerciales';
import {MesProduitsUBProfilDetail} from './ub/MesProduitsUBProfilDetail';

/**
 * Onglet "UB essentielles" dans Mes Produits (mode commercial uniquement).
 */
export const MesProduitsUBView: React.FC = () => {
  const {t} = useTranslation();
  const clientNav = useClient();
  const clientHook = useHalState(clientNav);
  const peutVoirUBEssentielles = usePeutVoirUBEssentielles();

  // Le follow est conditionné par la permission pour éviter un fetch sur un nav non-résolvable.
  const profilsHook = useHalCollection(
    peutVoirUBEssentielles ? clientNav.follow('profils_ub') : undefined,
  );
  const profilsUB = profilsHook.items ?? [];

  // On attend que le state du client soit chargé avant de décider de la redirection,
  // sinon `peutVoirUBEssentielles` est false par défaut pendant le loading initial.
  if (clientHook.loading) {
    return (
      <Center py='10'>
        <Spinner />
      </Center>
    );
  }

  // Sinon redirection vers le parent si l'utilisateur n'a pas la permission d'accès à cet onglet.
  if (!peutVoirUBEssentielles) {
    return (
      <Navigate
        to='..'
        replace
      />
    );
  }

  if (profilsHook.loading) {
    return (
      <Center py='10'>
        <Spinner />
      </Center>
    );
  }

  if (profilsUB.length === 0) {
    return (
      <Box p='6'>
        <Text
          textAlign='center'
          color='gray.dark'
        >
          {t('client.mes_produits.ub_essentielles.aucun_profil')}
        </Text>
      </Box>
    );
  }

  // Affiche tous les profils empilés. Le header (nom du profil) n'est rendu
  // que s'il y en a plusieurs — UX inutilement chargée pour le cas courant 1 profil.
  return (
    <VStack
      alignItems='stretch'
      spacing={0}
    >
      {profilsUB.map((profilUB) => (
        <MesProduitsUBProfilDetail
          key={profilUB.data.id}
          profilUB={profilUB}
          showHeader={profilsUB.length > 1}
        />
      ))}
    </VStack>
  );
};
